export enum FeatureFlag {
  DashboardCustomRoles = 'dashboard-custom-roles',
  EnableAchTransferBatches = 'enable-ach-transfer-batches',
  EnableAPIKeyPermissions = 'enable-api-key-permissions',
  EnableCustomCSVStatements = 'enable-custom-csv-statements',
  EnableDeviceMFA = 'enable-device-mfa',
  EnableExternalApps = 'enable-external-apps',
  EnableLiveModeMfaRequired = 'enable-live-mode-mfa-required',
  EnableLoanSearch = 'enable-loan-search',
  EnableNotificationConfiguration = 'enable-notification-configuration',
  EnablePaniniCheckScanner = 'enable-panini-check-scanner',
  EnablePasskeyAuth = 'enable-passkey-auth',
  EnableTransferApprovals = 'enable-transfer-approvals',
  EnableTransferApprovalPage = 'enable-transfer-approval-page',
  EnableTransferBatches = 'enable-transfer-batches',
  EnableTransferSearch = 'enable-transfer-search',
  HasInternationalWires = 'has-international-wires',
}
